import React, { useEffect, useState, useCallback } from 'react';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";

function DepositWallet() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [tabelLoading, setTableLoading] = useState(false); 
  const [depositWallet, setWallets] = useState([]); 
  const [viewData, setViewData] = useState("");
  const timestampInSeconds = Math.floor(Date.now() / 1000);

  const [editStatus, setEditStatus] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const fetchDepositData = useCallback(async () => {
    try {
      const wallet = await fetch(`${baseurl}/wallet/list`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        }
      });

      if (wallet.status === 429) {
        console.error("Rate limit exceeded. Please try again later.");
        return;
      }

      const walletResult = await wallet.json();

      if (walletResult.status) {
        setWallets(walletResult);
      }
    } catch (err) {
      console.error('Fetch error:', err);
    } finally {
      setTableLoading(true);
    }
  }, [authToken, baseurl]);

  useEffect(() => {
    fetchDepositData();
  }, [fetchDepositData]);


  const passData = (depositData) => {
    setViewData(depositData);
  };
  


  const updateDeposit =  async () =>{

    

    if (!editStatus) return setError("Select Status.");
    if (!password) return setError("Enter Password.");
  
    
    const formData = { 
        wallet_id : viewData.id,
        wallet_status:editStatus,
        password: password 
    };
  
    console.log("Sending Data:", formData);
  
   
      const response = await fetch(`${baseurl}/wallet/update`, {
        method: "POST",
        headers: {
           "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json(); // Get raw response
      console.log("Raw API Response:", data); // Log response before parsing
     
  
      if(data.status){
        toast.success(data.message)
        window.location.href = "";
      }
      else
      {
        toast.error(data.message)

      }
    
  }


 
  return (
    <>
    <Header>
     <Auth/>
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Deposit Wallets</h4>
                
              </div>
            </div>
            {/* End Page Header */}

            {/* row */}
            <div className="row">
              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-primary-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WALLETS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                             {depositWallet.totalWallet || '0'}

                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline" />
                </div>
              </div>

              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">HOLD WALLETS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {depositWallet.holdWallet || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE WALLETS</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                      <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                          {depositWallet.activeWallet || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
            </div>

            {/* row closed */}
          
            {/* row opened */}
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Deposit Wallets</h3>
                  </div>
                  <div className="table-responsive country-table">
                  {tabelLoading ? (
                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                    
                      <thead>
                        <tr>
                          <th className="wd-lg-25p">Wallet Address</th>
                          <th className="wd-lg-25p">NETWORK</th>
                          <th className="wd-lg-25p">WALLET STATUS</th>
                          <th className="wd-lg-25p">DEPOSIT STATUS</th>
                          <th className="wd-lg-25p">ACTION</th>
                        </tr>
                      </thead>
                     
                        <tbody>
                        {depositWallet.data.length > 0 ? (
                            depositWallet.data.map((depositData, index) => (
                            <tr key={index}>
                                <td>{depositData.wallet_address || 'N/A'}</td>
                                <td> {depositData.wallet_type || 'N/A'} </td>
                                <td> 
                                {depositData && depositData.status
                                    ? depositData.status === 'active' ? (
                                        <span className="badge bg-success">Active</span>
                                    ) : (
                                        <span className="badge bg-danger">{depositData.status} </span>
                                    ): 'N/A'}
                               </td>

                                <td> 
                                {depositData && depositData.open_timestamp
                                    ? depositData.open_timestamp  > timestampInSeconds ? (
                                        <span className="badge bg-primary">in-process</span>
                                    ) : (
                                        <span className="badge bg-success">{"Closed"} </span>
                                    ): 'N/A'}
                                     </td>
                                <td>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a data-bs-effect="effect-scale" onClick={() => passData(depositData)} data-bs-toggle="modal" href="#modaldemo8" className="btn btn-sm btn-warning">
                                    <i className="fa fa-edit"></i>
                                </a>
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td>No Data Found</td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                      ):(
                        <div className="text-center">
                             <div class="d-flex justify-content-center mb-4">
                                  <div class="spinner-border" role="status">
                                      <span class="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                            </div>
                      )}
                      
                    
                  </div>
                </div>
              </div>
            </div>
            {/* /row */}

          </div>
        </div>


        <div class="modal fade"  id="modaldemo8">
            <div class="modal-dialog modal-dialog-centered text-center" role="document">
                <div class="modal-content modal-content-demo">
                    <div class="modal-header">
                        <h6 class="modal-title">Update Status </h6><button aria-label="Close" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Address</b></span>
                        </label>
                        <span className="ms-auto">{viewData.wallet_address || 'N/A'}</span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Status</b></span>
                        </label>
                        <span className="ms-auto">
                            <select 
                                className="form-control" 
                                value={editStatus} 
                                onChange={(e) => setEditStatus(e.target.value)}
                            >
                                <option value="">select Status</option>
                                <option value="active">active</option>
                                <option value="hold">hold</option>
                            </select>
                        </span>
                    </div>

                    <div className="d-flex p-3 border-top">
                        <label>
                            <span><b className="text-primary">Password</b></span>
                        </label>
                        <input type="text"  className="form-control" value={password} onChange={(e)=>setPassword(e.target.value)}/>
                    </div>
                    <span>{error}</span>
                </div>

                <div className="modal-footer">
                    <button className="btn btn-primary" onClick={updateDeposit}>Save changes</button> 
                    <button className="btn btn-light" data-bs-dismiss="modal">Close</button>
                </div>

                </div>
            </div>
        </div>
        <ToastContainer/>
        </Header>


      <Footer/>

    </>
  )
}

export default DepositWallet